import styled from 'styled-components';

export const GalleryContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  padding: 1rem 1.25rem 1.25rem;
`;

export const GalleryStage = styled.div`
  align-items: center;
  display: flex;
  gap: 0.75rem;
  justify-content: center;
  min-height: 15rem;
`;

export const PreviewImage = styled.div`
  align-items: center;
  background: ${(props) => props.theme.colors.background};
  border-radius: 1rem;
  display: flex;
  justify-content: center;
  min-height: 14rem;
  min-width: 10rem;
  overflow: hidden;
  padding: 0.75rem;
  width: 100%;

  & > div {
    height: min(58vh, 32rem);
    max-width: 100%;
    width: auto;
  }

  & img {
    height: min(58vh, 32rem);
    object-fit: contain;
    width: auto;
  }
`;

export const GalleryArrow = styled.button`
  align-items: center;
  background: ${(props) => props.theme.colors.background};
  border: 1px solid ${(props) => `${props.theme.colors.primary}30`};
  border-radius: 999px;
  color: ${(props) => props.theme.colors.primary};
  cursor: pointer;
  display: inline-flex;
  flex: 0 0 2.5rem;
  height: 2.5rem;
  justify-content: center;

  &:hover {
    background: ${(props) => `${props.theme.colors.primary}12`};
  }

  &:focus-visible {
    outline: 2px solid ${(props) => props.theme.colors.primary};
    outline-offset: 2px;
  }
`;

export const ImagePosition = styled.p`
  color: ${(props) => props.theme.colors.textLight};
  font-size: 0.8rem;
  font-weight: 600;
  margin: 0;
  text-align: center;
`;

export const ThumbnailStrip = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  justify-content: center;
`;

export const ThumbnailButton = styled.button<{ $selected: boolean }>`
  background: transparent;
  border: 2px solid ${(props) => (props.$selected ? props.theme.colors.primary : 'transparent')};
  border-radius: 0.85rem;
  cursor: pointer;
  opacity: ${(props) => (props.$selected ? 1 : 0.68)};
  padding: 0.15rem;

  &:hover {
    opacity: 1;
  }

  &:focus-visible {
    outline: 2px solid ${(props) => props.theme.colors.primary};
    outline-offset: 2px;
  }
`;
